import React, { useContext } from "react";
import { 
    Form,
    Container, Row, Col, Button, Modal, Card, Image } from "react-bootstrap";
import { colors, contact, mainImage } from "../configs";

const { white } = colors;


function Modal_LoginByEmail({
  backdrop=true, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  size='md',
  header='',
  onClick,
  value,
  handleFormChange,
  formData
}) {


  return (
    <Modal
      backdrop={backdrop}
      animation={animation}
      show={show}
      onHide={onHide}
      centered={centered}
      size={size}
    >
      <Modal.Header closeButton>
        <h1><b>เข้าใช้งานด้วยอีเมล</b></h1>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'transparent'}} >
            <Form.Floating className="mb-3" style={styles.container4} >
                <Form.Control
                    name="email"
                    type="email"
                    placeholder="name@example.com"
                    onChange={handleFormChange}
                />
                <label >อีเมล</label>
            </Form.Floating>
            <Form.Floating className="mb-3" style={styles.container4} >
                <Form.Control
                    name="password"
                    type="password"
                    placeholder="Password"
                    onChange={handleFormChange}
                />
                <label >รหัสผ่าน</label>
            </Form.Floating>
            {!!formData.email && !!formData.password
                ?<Button onClick={onClick} variant="dark" style={styles.container3} >เข้าสู่ระบบ</Button>
                :<Button onClick={()=>{alert('กรุณาใส่ข้อมูลให้ครบถ้วน')}} variant="secondary" style={styles.container3} >เข้าสู่ระบบ</Button>
            }
      </Modal.Body>
    </Modal>
  );
};

const styles = {
    container : {
      width: "100%",
      height: "100vh", // Full viewport height
      backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/owner%2Fshopchamp_background_with_logo.png?alt=media&token=4cb0cdba-57a9-4de0-9fbe-71d8b41ee760')",
      backgroundSize: "cover", // Ensures the image covers the entire div
      backgroundPosition: "center", // Centers the image
      backgroundRepeat: "no-repeat", // Prevents image from repeating
      display:'flex',
      justifyContent:'center',
      alignItems:'center'
    },
    container2 : {
      backgroundColor:white,
      borderRadius:50,
      padding:20,
      paddingTop:5,
      display:'flex',
      flexDirection:'column',
      alignItems:'center',
      width:'25%',
      minWidth:'300px',
      opacity:0.9,
      marginTop:100
    },
    container3 : {
      width:'100%',borderRadius:20,marginTop:10,paddingTop:30,paddingBottom:30, marginBottom:10
    },
    container4 : {
      width:'100%'
    },
    container5 : {
      display:'flex',width:'50%',justifyContent:'flex-end',minWidth:320
    },
    img : {
      width: '200px', borderRadius:'1rem'
    }
  }

export default Modal_LoginByEmail;
